import React, { FC } from 'react';
import cls from "../Table.module.scss";
import CheckboxActive from "src/assets/icons/check/CheckboxActiveIcon";
import CheckboxUnactive from "src/assets/icons/check/CheckboxUnactiveIcon";
import {useTypedSelector} from "src/hooks/useTypedSelector";
import selectors from "src/redux/selectors";
import {useAppDispatch} from "src/redux";
import {toggleAllSelectedRows} from "src/redux/slices/selectedRows";
const MainCheckboxCell:FC = () => {
  const dispatch = useAppDispatch()
  const isAllRowsSelected = useTypedSelector(selectors.getIsAllRowsSelected);
  const toggleAllSelectedRowsHandler = () => {
    dispatch(toggleAllSelectedRows())
  }
  return (
    <th className={`${cls['selection-cell']}`}>
      {
        isAllRowsSelected
          ? <CheckboxActive onClick={toggleAllSelectedRowsHandler} />
          : <CheckboxUnactive onClick={toggleAllSelectedRowsHandler} />
      }
    </th>
  );
}


export default MainCheckboxCell;
